/**
 * 買えるLEON: 旧 custom.js (jQueryスムーススクロール) の vanilla JS 移植。
 * 挙動: ページ内アンカーへ -100px オフセット付きでスムーススクロール。
 * URLハッシュ付きで開いた場合もオフセットを適用する。
 */
/* 旧テーマ同様の機能検出クラスをhtmlへ付与（kl-legacy.cssの supports-* セレクタ前提） */
(function () {
  var el = document.documentElement;
  /* 旧同様 head の同期スクリプト（kl-custom-head.liquid）が先に付与するため、
     ここは未付与時のフォールバック。二重付与しないようガードする */
  var tokens = ' ' + el.className + ' ';
    if (tokens.indexOf(' supports-sticky ') >= 0 || tokens.indexOf(' no-supports-sticky ') >= 0) return;
  el.className = el.className.replace('no-js', 'js');
  if (el.className.indexOf('js') === -1) el.className += ' js';
  el.className += ((window.CSS && window.CSS.supports('(position: sticky) or (position: -webkit-sticky)')) ? ' supports-sticky' : ' no-supports-sticky');
  el.className += (window.matchMedia('(-moz-touch-enabled: 1), (hover: none)')).matches ? ' no-supports-hover' : ' supports-hover';
})();

(function () {
  var ADJUST = -100;

  function scrollToAnchor(hash, adjust) {
    var target;
    try {
      target = hash === '#' || hash === '' ? document.documentElement : document.querySelector(hash);
    } catch (e) {
      return; // 無効なセレクタは無視
    }
    if (!target) return;
    var position = target.getBoundingClientRect().top + window.pageYOffset + (typeof adjust === 'number' ? adjust : ADJUST);
    window.scrollTo({ top: position, behavior: 'smooth' });
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (location.hash) {
      window.scrollTo(0, 0);
      setTimeout(function () { scrollToAnchor(decodeURI(location.hash)); }, 100);
    }
  });

  /* 対象リンクの判定。capture段の preventDefault と bubble段のスクロールで同じ条件を共有する */
  function matchAnchorLink(event) {
    var eventTarget = event.target;
    if (!eventTarget || typeof eventTarget.closest !== 'function') return null;
    // 旧theme.jsのデリゲートは '[href^="#"], [data-href]'（slideshow下矢印 .Slideshow__ScrollButton が data-href を持つ）
    var link = eventTarget.closest('a[href^="#"], [data-href]');
    if (!link) return null;
    // v11テーマのUI部品(タブ・ドロワー等)の制御用リンクには干渉しない
    if (link.hasAttribute('allow-hash-change') || link.getAttribute('role') === 'tab' || link.closest('[data-no-smooth-scroll]')) return null;
    return link;
  }

  /* capture段で preventDefault だけ先に済ませる理由（＝スムーススクロール二重の解消）:
     v11 theme.js:6123 が document.documentElement へ 'a[href*="#"]' のクリック委譲を張っており、
     同一パスのハッシュリンクを preventDefault + scrollIntoView(オフセット0) してから
     'hashchange:simulate' を発火する。これは bubble 段なので、こちらを document の bubble 段だけに
     置くと「v11がオフセット0へスクロールを開始 → 直後に旧仕様の -100px で上書き」の二段動作になる。
     v11 のハンドラは先頭で event.defaultPrevented を見て降りるので、capture 段で preventDefault して
     おけば v11 側は何もせず、旧 custom.js（$.on(...) + return false でtheme.js側の委譲へ伝播させない）
     と同じ「実装は1つだけ」に戻る。
     スクロール実行は従来どおり bubble 段のまま。間のハンドラが stopPropagation した場合
     （カルーセルのドラッグ後クリック抑止 = kl-slideshow.liquid:292 / kl-recently-viewed-products.liquid:175 等）
     はスクロールしないが、それらは自身でも preventDefault しているので抑止側の意図どおりで差は出ない。 */
  document.addEventListener('click', function (event) {
    var link = matchAnchorLink(event);
    if (!link) return;
    var raw = link.matches('a[href^="#"]') ? (link.getAttribute('href') || '') : (link.getAttribute('data-href') || '');
    if (raw === '#' || raw === '') return; /* 旧同様、href="#" は何もしない */
    event.preventDefault();
  }, true);

  document.addEventListener('click', function (event) {
    var link = matchAnchorLink(event);
    if (!link) return;
    var raw = link.matches('a[href^="#"]') ? (link.getAttribute('href') || '') : (link.getAttribute('data-href') || '');
    /* 旧theme.js:7952-7954 は href="#" だけのリンクを早期returnしていた。
       これが無いと「MORE」ボタン等でページ最上部へ飛ぶ */
    if (raw === '#' || raw === '') return;
    var hash = link.matches('a[href^="#"]') ? decodeURI(link.hash || '') : decodeURI(link.getAttribute('data-href') || '');
    event.preventDefault();
    /* 旧theme.js: data-offset を持つアンカー(商品ギャラリーのサムネ/ドット等)はその値を使う */
    var adjust = link.hasAttribute('data-offset') ? parseInt(link.getAttribute('data-offset'), 10) : undefined;
    scrollToAnchor(hash === '#' ? '' : hash, adjust);
  });
})();

/* KL: 旧 product-form.liquid のunisizeガイドリンク挿入スクリプト移植（#unisize_tag があるページのみ動作） */
(function () {
  var NOTE_ID = 'unisizeNote';

  function ensureLinkContainer(unisizeTag) {
    var linkContainer = document.querySelector('.unisize-guide-link-container');
    if (!linkContainer) {
      linkContainer = document.createElement('div');
      linkContainer.className = 'unisize-guide-link-container Link Link--underline';

      var link = document.createElement('a');
      link.textContent = 'unisizeご利用ガイドはこちら';
      link.href = '/pages/unisize';
      link.setAttribute('data-unisize-guide', 'true');
      link.className = 'unisize-guide-link';

      linkContainer.appendChild(link);
      unisizeTag.appendChild(linkContainer);
    }
    return linkContainer;
  }

  function ensureNote(unisizeTag) {
    var note = document.getElementById(NOTE_ID);
    if (!note) {
      note = document.createElement('p');
      note.id = NOTE_ID;
      note.className = 'unisize_info Rte';
      note.textContent = '※unisizeの「おすすめサイズ」は参考値としてご提供しております。個人差がございますので、サイズ表と併せてご確認のうえ、ご判断ください。';
      unisizeTag.appendChild(note);
    }
    return note;
  }

  function fixGuideLinkPosition() {
    var unisizeTag = document.getElementById('unisize_tag');
    var unisizeBanner = document.getElementById('unisizeBanner');
    if (!unisizeTag || !unisizeBanner) return;

    var linkContainer = ensureLinkContainer(unisizeTag);
    var note = ensureNote(unisizeTag);

    if (unisizeBanner.nextSibling !== linkContainer) {
      unisizeTag.insertBefore(linkContainer, unisizeBanner.nextSibling);
    }

    if (linkContainer.nextSibling !== note) {
      unisizeTag.insertBefore(note, linkContainer.nextSibling);
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    if (!document.getElementById('unisize_tag')) return;
    var observer = new MutationObserver(fixGuideLinkPosition);
    observer.observe(document.body, { childList: true, subtree: true });
    fixGuideLinkPosition();
  });
})();

/* KL: 旧theme.jsのドロワー開閉とCollapsible開閉のvanilla再実装。
   ドロワー（旧 theme.js:919-1050 Drawer）:
     [data-action="open-drawer"][data-drawer-id] クリックで対象の aria-hidden を false、
     [data-action="close-drawer"] で true。開状態のCSSは .Drawer[aria-hidden=false]。
     開時は html に no-scroll（kl-legacyスコープ外のため inline overflow で代替）、
     .PageOverlay（複数あり得るため全件）に is-visible を付与しクリックで閉じる。
     opener の aria-expanded を open/close で同期。
     開時とウィンドウ resize 時に maxHeight を innerHeight にクランプ（旧 _calculateMaxHeight）。
     旧 Drawer.open() は search:close を発火して検索を閉じていた →
     ここでは document へ kl:drawer-open を発火（受け手は検索モーダル側の実装）し、
     フォールバックとして #Search の aria-hidden も直接戻す。
   Collapsible（旧 theme.js:3110-3190 + Animation slideUp/slideDown 7章）:
     グローバル実装はこの1本のみ（kl-product.js 側の同等実装は撤去済み）。
     window.klCollapsible = { open, close, toggle } として公開。 */
/* KL: フォーカストラップ（旧theme.jsのa11y挙動）。ドロワー/モーダル/検索で共用 */
(function () {
  /* 旧 helper/Accessibility（旧theme.js:841-904）の移植。旧は namespace ごとに focusin リスナを
     持つ「多重トラップ」構造だった:
       trapFocus(container, ns)       旧852-868 … container に tabindex="-1" を付けて focus し、
                                                  ns の focusin リスナ（コンテナ外へ出たら
                                                  container.focus() で引き戻す）を登録
       removeTrapFocus(container, ns) 旧876-884 … container の tabindex を外し、ns のリスナだけ解除。
                                                  フォーカスは動かさない
       clearTrapFocus()               旧892-900 … 全 namespace のリスナを解除して listeners を空にする。
                                                  tabindex は外さず、フォーカスも動かさない
     複数トラップが同時に有効だと focusin リスナ同士が引っ張り合うため、旧 Modal._openModal
     （旧theme.js:3316）は「ポップオーバーの上にモーダルが開く」ケース用に必ず clearTrapFocus() を
     先に呼んでいた。ここでも同じ構造（namespace 付き登録 + clear + 個別解除）を再現する。
     旧は同時登録時「最後に登録されたリスナが実質勝つ」ため、キー操作の対象は最後に張られた
     有効なトラップ（＝配列末尾）とする。 */
  var traps = [];        // 登録順のトラップ一覧（末尾が最後に張られたもの）
  var activeTrap = null; // キー操作の対象。clear() で全て無効化されると null
  var autoNamespace = 0;

  function focusables(el) {
    return Array.prototype.filter.call(
      el.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'),
      function (n) { return n.offsetParent !== null || n === document.activeElement; }
    );
  }

  /* トラップ対象がもう開いていない場合の保険。移植版にはコレクションのフィルタドロワー
     （sections/kl-collection-template*.liquid のインライン closeDrawer）のように、
     kl-custom.js の close()＝release() を通らず aria-hidden="true" に戻すだけの実装が同居している。
     旧テーマは Drawer.close() が必ず removeTrapFocus を呼ぶ構造でこの状況が起きなかったため、
     取り残されたトラップがキー操作を奪わないようここで無効扱いにする。 */
  function isTrapUsable(entry) {
    return !!entry && !!entry.container && document.contains(entry.container) &&
      entry.container.getAttribute('aria-hidden') !== 'true';
  }

  function onKeydown(e) {
    if (e.key !== 'Tab' || !activeTrap || !isTrapUsable(activeTrap)) return;
    var container = activeTrap.container;
    var f = focusables(container);
    if (f.length === 0) {
      /* フォーカス可能な子が無い場合、旧の focusin 方式では Tab を押しても
         すぐコンテナへ引き戻されて外へ出られなかった。同じ結果になるよう Tab を無効化する */
      e.preventDefault();
      return;
    }
    var first = f[0], last = f[f.length - 1];
    /* 旧は focusin リスナ方式（旧theme.js:861-867）＝「コンテナ外へフォーカスが移った瞬間に
       container.focus() で引き戻す」。こちらは keydown ループ方式なので、旧と同じ結果になるよう
       ケースごとに合わせる。 */
    if (!container.contains(document.activeElement) && document.activeElement !== container) {
      /* フォーカスがトラップ外にある（オーバーレイのクリック等で body に落ちた場合など）。
         旧はどこへ移ってもコンテナへ引き戻していたので同じ結果にする */
      e.preventDefault();
      container.focus();
      return;
    }
    if (document.activeElement === container) {
      /* コンテナ自身にフォーカスがある状態（trap 直後＝下記 trap() のコンテナ focus）。旧では
           Tab       → コンテナの次のタブ位置＝コンテナ内の先頭要素へ進む（外へ出ないので引き戻し無し）
           Shift+Tab → コンテナ直前の要素（＝トラップ外）へ移った瞬間に引き戻されるので、
                       結果として「何も動かない＝コンテナに留まる」
         これに合わせ、Shift+Tab は既定動作を潰すだけ、Tab はブラウザ既定（先頭要素へ）に任せる。
         ここで last.focus() をすると、overflow:auto の Modal--fullScreen（サイズ表モーダル、
         kl-legacy.css:11271-11288/11319）が最下部の .Modal__Close までスクロールしてしまう。 */
      if (e.shiftKey) e.preventDefault();
      return;
    }
    /* 端で折り返す場合も着地点は last/first ではなく「コンテナ自身」。旧の focusin 方式は
       トラップ外へ出た瞬間に container.focus() で引き戻していたため、先頭からの Shift+Tab も
       末尾からの Tab もコンテナに戻るのが正しい。last/first へ飛ばすと overflow:auto の
       Modal--fullScreen（サイズ表モーダル）が端までスクロールしてしまう。 */
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); container.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); container.focus(); }
  }

  /* 有効なトラップのうち最後に張られたものを選び直す（旧: 最後に登録された focusin リスナが勝つ） */
  function syncActive() {
    activeTrap = null;
    for (var i = traps.length - 1; i >= 0; i--) {
      if (traps[i].active) { activeTrap = traps[i]; break; }
    }
    if (activeTrap) {
      document.addEventListener('keydown', onKeydown, true);
    } else {
      document.removeEventListener('keydown', onKeydown, true);
    }
  }

  /* 解除対象の特定。引数省略時は最後に登録されたもの（呼び出し側は LIFO で開閉する）。
     namespace 文字列でも、コンテナ要素そのものでも指定できる */
  function findIndex(target) {
    if (target === undefined || target === null) return traps.length - 1;
    for (var i = traps.length - 1; i >= 0; i--) {
      if (traps[i].namespace === target || traps[i].container === target) return i;
    }
    return -1;
  }

  window.klFocusTrap = {
    /* trap(el, namespace): 旧 Accessibility.trapFocus(container, namespace)（旧theme.js:852-868）。
       namespace 省略時は自動採番（旧も呼び出し側ごとに固有の名前を渡していた）。
       旧は同名 namespace の再登録で古いリスナが残る実装だったが、ここでは古い登録を捨てて置き換える */
    trap: function (el, namespace) {
      if (!el) return;
      var ns = namespace || ('kl-trap-' + (++autoNamespace));

      // 同じ namespace / 同じコンテナの古い登録は捨てる（副作用は起こさない）
      for (var i = traps.length - 1; i >= 0; i--) {
        if (traps[i].namespace === ns || traps[i].container === el) traps.splice(i, 1);
      }

      traps.push({
        namespace: ns,
        container: el,
        active: true,
        /* 旧 removeTrapFocus はフォーカスを戻さなかったが、移植版は解除時に opener へ戻す。
           トラップごとに記憶することで、上に別のトラップ（モーダル等）が乗っても
           それぞれ自分の opener に戻れる */
        lastFocused: document.activeElement
      });
      syncActive();

      /* 旧 trapFocus の焦点決定ロジック（旧theme.js:855-859）をそのまま再現する:
             var elementToFocus = container.querySelector('[autofocus]') || container;
             container.setAttribute('tabindex', '-1');
             elementToFocus.focus();
         ＝ [autofocus] が無ければ「コンテナ内の先頭要素」ではなく「コンテナ自身」を focus する。
         旧theme.css:2437 の .Drawer:focus{outline:none}（kl-legacy.css:8700）が、コンテナ自身が
         focus される前提だった裏付け。
         先頭のフォーカス可能要素を focus すると、overflow:auto を持つ .Modal
         （kl-legacy.css:11271-11288、サイズ表は Modal--fullScreen で height:100% ＝ 同11319）が
         開いた瞬間に先頭リンクや最下部の閉じるボタンの位置まで勝手にスクロールしてしまう。
         [autofocus] を持つ住所モーダル（templates/customers/addresses.liquid の氏名欄）は
         旧同様その入力が focus されるため挙動は変わらない。
         なお tabindex="-1" のコンテナに focus してもアウトラインは出ない
         （kl-legacy.css:7295 の :not(.is-tabbing) [tabindex]:focus{outline:none}。
          .is-tabbing は旧・新とも .kl-legacy には付かない） */
      el.setAttribute('tabindex', '-1');
      var elementToFocus = el.querySelector('[autofocus]') || el;
      elementToFocus.focus();
    },
    /* release(target): 旧 Accessibility.removeTrapFocus(container, namespace)（旧theme.js:876-884）。
       target は namespace でもコンテナ要素でもよく、省略時は最後に登録されたトラップを解除する
       （既存の呼び出しは全て引数なし＝自分が最後に張ったものを解除する使い方） */
    release: function (target) {
      var index = findIndex(target);
      if (index === -1) return;

      var entry = traps[index];
      var wasActive = entry === activeTrap;
      traps.splice(index, 1);
      syncActive();

      /* 旧 removeTrapFocus（旧theme.js:877-879）と同じく trap 時に付けた tabindex を外す。
         clear() で無効化されたトラップ（＝上にモーダルが乗ったポップオーバー等）でも、
         旧同様この解除で必ず外れる */
      if (entry.container) entry.container.removeAttribute('tabindex');

      /* フォーカス復帰は「いま前面だったトラップ」を解除したときだけ。無効化済みのトラップまで
         復帰させると、前面にあるモーダル等からフォーカスを奪ってしまう（旧はそもそも復帰しない） */
      if (wasActive && entry.lastFocused && entry.lastFocused.focus && document.contains(entry.lastFocused)) {
        entry.lastFocused.focus();
      }
    },
    /* clear(): 旧 Accessibility.clearTrapFocus（旧theme.js:892-900）。全トラップを無効化するが、
       tabindex は外さずフォーカスも動かさない（各トラップの解除は後で release() が行う）。
       旧 Modal._openModal（旧theme.js:3316）が「ポップオーバーの上にモーダルが開く」ために呼んでいた */
    clear: function () {
      traps.forEach(function (entry) { entry.active = false; });
      syncActive();
    }
  };
})();

(function () {
  var openDrawerElement = null;
  var openDrawerOpener = null;

  function setScrollLock(lock) {
    document.documentElement.style.overflow = lock ? 'hidden' : '';
  }

  function getOverlays() {
    return Array.prototype.slice.call(document.querySelectorAll('.PageOverlay'));
  }

  function onOverlayClick() {
    if (openDrawerElement) close(openDrawerElement);
  }

  /* 旧 Drawer._calculateMaxHeight（旧theme.js:1030-1034）の移植。
     ドロワーが常に画面内に収まるよう maxHeight を window.innerHeight にクランプする。
     .Drawer は kl-legacy.css で height:100vh / max-height:none のため、モバイルの
     URLバー分だけ 100vh > innerHeight となりはみ出す。それを防ぐのが本処理。
     kl-base.css 側で height:100dvh 等の対応が入っても、inline の max-height は
     CSS の height より優先して要素を縮めるだけなので二重適用の害は無い（小さい方に収まる）。 */
  function calculateMaxHeight(drawer) {
    drawer.style.maxHeight = window.innerHeight + 'px';
  }

  /* 旧テーマは Drawer インスタンスごとに window resize リスナを張っていた（旧theme.js:1023、
     解除は destroy 旧theme.js:945）。ここでは .kl-legacy 配下の全 .Drawer を走査して同じ結果を得る。
     こうすることで、このモジュールを経由せずセクション側にインライン実装されている
     コレクションのフィルタドロワー（kl-collection-template*.liquid）もまとめてクランプされる。 */
  function calculateAllMaxHeights() {
    Array.prototype.forEach.call(document.querySelectorAll('.kl-legacy .Drawer'), calculateMaxHeight);
  }

  window.addEventListener('resize', calculateAllMaxHeights);

  function open(drawer, opener) {
    /* 旧 Drawer.open() 冒頭の search:close 相当。検索モーダル側がこのイベントを拾って閉じる */
    document.dispatchEvent(new CustomEvent('kl:drawer-open'));
    var searchElement = document.getElementById('Search');
    if (searchElement && searchElement.getAttribute('aria-hidden') === 'false') {
      searchElement.setAttribute('aria-hidden', 'true');
    }

    if (openDrawerElement && openDrawerElement !== drawer) close(openDrawerElement);

    drawer.setAttribute('aria-hidden', 'false');
    calculateMaxHeight(drawer); // 旧 Drawer.open() の _calculateMaxHeight 呼び出し（旧theme.js:967）
    openDrawerElement = drawer;
    openDrawerOpener = opener || null;
    setScrollLock(true);

    getOverlays().forEach(function (overlay) {
      overlay.classList.add('is-visible');
      overlay.addEventListener('click', onOverlayClick);
    });

    /* 旧 Drawer.open()（旧theme.js:976）の
       document.querySelector('#shopify-section-header').style.zIndex = '' 相当。
       検索を開いたときに上げたヘッダーのz-indexを戻し、ドロワー表示中はヘッダーも
       オーバーレイの下に入るようにする（旧のコメントどおり "Ugly hack" だが挙動を揃える） */
    var hdrSection = document.querySelector('.shopify-section--header');
    if (hdrSection) hdrSection.style.zIndex = '';

    /* 旧 Drawer.open()（旧theme.js:974）の trapFocus(this.element, 'drawer') 相当 */
    if (window.klFocusTrap) window.klFocusTrap.trap(drawer, 'drawer');
  }

  function close(drawer) {
    drawer.setAttribute('aria-hidden', 'true');
    if (openDrawerElement === drawer) {
      openDrawerElement = null;
      if (openDrawerOpener) {
        openDrawerOpener.setAttribute('aria-expanded', 'false');
        openDrawerOpener = null;
      }
    }
    setScrollLock(false);

    getOverlays().forEach(function (overlay) {
      overlay.classList.remove('is-visible');
      overlay.removeEventListener('click', onOverlayClick);
    });

    /* 旧 Drawer.close()（旧theme.js:1004）の removeTrapFocus(this.element, 'drawer') 相当。
       このドロワーのトラップだけを狙って解除する（別のトラップを巻き添えにしない） */
    if (window.klFocusTrap) window.klFocusTrap.release(drawer);
  }

  /* --- Collapsible: 旧 theme.js の Animation.slideUp/slideDown + Collapsible の忠実移植 --- */

  function slideUp(element) {
    element.style.height = element.scrollHeight + 'px'; // transitionのため現在高さを一旦確定
    element.offsetHeight; // force redraw
    element.style.height = 0;
  }

  function slideDown(element) {
    if (element.style.height === 'auto') return;
    element.style.height = element.firstElementChild.scrollHeight + 'px';
    var transitionEnded = function (event) {
      if (event.propertyName === 'height') {
        element.style.height = 'auto'; // 開き切ったらコンテンツの伸縮に追従
        element.removeEventListener('transitionend', transitionEnded);
      }
    };
    element.addEventListener('transitionend', transitionEnded);
  }

  /* 旧 Dom.getSiblings（フィルタなし呼び出し）相当: 前後すべての兄弟要素 */
  function getSiblings(element) {
    var siblings = [];
    var el = element.parentNode ? element.parentNode.firstElementChild : null;
    for (; el; el = el.nextElementSibling) {
      if (el !== element) siblings.push(el);
    }
    return siblings;
  }

  function openCollapsible(collapsible) {
    var toggleButton = collapsible.querySelector('.Collapsible__Button'),
        collapsibleInner = collapsible.querySelector('.Collapsible__Inner');
    if (!collapsibleInner || !toggleButton || toggleButton.getAttribute('aria-expanded') === 'true') return;
    toggleButton.setAttribute('aria-expanded', 'true');
    collapsibleInner.style.overflow = 'visible';
    slideDown(collapsibleInner);
  }

  function closeCollapsible(collapsible) {
    var toggleButton = collapsible.querySelector('.Collapsible__Button'),
        collapsibleInner = collapsible.querySelector('.Collapsible__Inner');
    if (!collapsibleInner || !toggleButton || toggleButton.getAttribute('aria-expanded') === 'false') return;
    toggleButton.setAttribute('aria-expanded', 'false');
    collapsibleInner.style.overflow = 'hidden';
    slideUp(collapsibleInner);
  }

  function toggleCollapsible(event, target) {
    var parentCollapsible = target.closest('.Collapsible');
    if (!parentCollapsible) return;

    /* 旧theme.js(実際に読み込まれていた非min版)の Collapsible--autoExpand ガードは
       matchesBreakpoint('Responsive')＝未定義ブレークポイント（常にfalsy）のため実質無効。
       theme.css 側の autoExpand ルールもコメントアウト済みだった。旧挙動に忠実にガードは移植しない。 */

    var isOpen = target.getAttribute('aria-expanded') === 'true';
    if (isOpen) {
      closeCollapsible(parentCollapsible);
    } else {
      openCollapsible(parentCollapsible);
    }

    /* 旧挙動: 兄弟要素は（セレクタフィルタなしで）すべて閉じる。
       Collapsible__Inner/Button を持たない兄弟は closeCollapsible のガードで no-op */
    getSiblings(parentCollapsible).forEach(closeCollapsible);
    event.preventDefault();
  }

  window.klCollapsible = {
    open: openCollapsible,
    close: closeCollapsible,
    toggle: toggleCollapsible
  };

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-action="open-drawer"]');
    if (opener) {
      var id = opener.getAttribute('data-drawer-id');
      var drawer = id ? document.getElementById(id) : null;
      if (drawer) {
        event.preventDefault();
        open(drawer, opener);
        opener.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    var closer = event.target.closest('[data-action="close-drawer"]');
    if (closer) {
      var target = closer.closest('.Drawer') || (openDrawerElement || null);
      if (target) {
        event.preventDefault();
        close(target);
      }
      return;
    }

    /* 背景(::before)クリックで閉じる: Drawer自身がターゲットのときのみ */
    if (openDrawerElement && event.target === openDrawerElement) {
      close(openDrawerElement);
      return;
    }

    var collapsibleButton = event.target.closest('[data-action="toggle-collapsible"]');
    if (collapsibleButton) {
      /* コレクションセクションのローカルハンドラとの二重発火防止（klHandledフラグ規約） */
      if (event.klHandled) return;
      toggleCollapsible(event, collapsibleButton);
      event.klHandled = true;
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && openDrawerElement) close(openDrawerElement);
  });
})();

/* KL: 旧theme.jsのRte内テーブル/動画ラップ（横スクロール用TableWrapper・レスポンシブ動画用VideoWrapper） */
(function () {
  function wrapRteEmbeds() {
    document.querySelectorAll('.kl-legacy .Rte table').forEach(function (table) {
      if (table.parentElement && table.parentElement.classList.contains('TableWrapper')) return;
      table.outerHTML = '<div class="TableWrapper">' + table.outerHTML + '</div>';
    });
    document.querySelectorAll('.kl-legacy .Rte iframe').forEach(function (iframe) {
      if (iframe.src.indexOf('youtube') === -1 && iframe.src.indexOf('youtu.be') === -1 && iframe.src.indexOf('vimeo') === -1) return;
      if (iframe.parentElement && iframe.parentElement.classList.contains('VideoWrapper')) return;
      iframe.outerHTML = '<div class="VideoWrapper">' + iframe.outerHTML + '</div>';
    });
  }
  if (/complete|interactive/.test(document.readyState)) wrapRteEmbeds();
  else document.addEventListener('DOMContentLoaded', wrapRteEmbeds);
})();

/* KL: 記事のスクロール追従バー（.ArticleToolbar）。旧 ArticleSection（旧theme.js:3920-4010）の移植。

   旧の実装:
     - sections.register('article', ArticleSection)（旧theme.js:7847）で
       [data-section-type="article"] のセクションごとにインスタンス化。
     - コンストラクタで .ArticleToolbar と .ArticleNav をセクション内から取得し、
       window の scroll に _checkToolbarVisibility を張る（旧theme.js:3968-3971）。
     - onUnload（旧theme.js:3953-3965）でその scroll リスナを外す。
       shopify:section:load / unload は SectionContainer（旧theme.js:6722-6723）が受けて
       インスタンスの生成・onUnload 呼び出しを行っていた。
     - _checkToolbarVisibility（旧theme.js:3973-4010）は fastdom で measure → mutate の順に:
         measure: lastYPosition = window.pageYOffset
                  headerHeight  = document.querySelector('.Header').offsetHeight
                  isFixedHeader = parseInt(getComputedStyle(document.body)
                                    .getPropertyValue('--use-sticky-header') || 0)
                  navBottom     = ArticleNav.offsetTop + ArticleNav.clientHeight - headerHeight
                                  （.ArticleNav がある場合のみ）
         mutate : toolbar.style.top = isFixedHeader ? headerHeight+'px' : null
                  .ArticleNav あり → 150 < y < navBottom のとき is-visible、それ以外は外す
                  .ArticleNav なし → 150 < y のとき is-visible、それ以外は外す
     - 初期化時には呼ばない（最初のスクロールイベントまでは非表示のまま）。

   旧本番（?preview_theme_id=162398535897, /blogs/contents/pmds-202610, 幅1300）での実測:
     headerHeight=135 / ArticleNav.offsetTop=4209 / clientHeight=674 → navBottom=4748
     y=149 非表示 / y=151 表示 / y=4728 表示 / y=4768 非表示。上記条件と完全に一致。

   移植の相違点は2つだけ:
     1. fastdom が無いので requestAnimationFrame で1フレーム1回に束ねる
        （旧も fastdom が次フレームまで measure/mutate を溜めるため結果は同じ）。
     2. .Header が無いページ（旧はここで例外になる）で headerHeight=0 として無視する。
        記事ページには必ず .Header があるので記事系セクションの挙動には影響しない。

   スコープ: 記事系セクションは9本（kl-article-template*.liquid）+ kl-main-article.liquid で、
   いずれも旧と同じ <article data-section-type="article" data-section-id="{{ section.id }}"> を
   出力する。旧と同様セレクタは [data-section-type="article"] のみに依存し、セクションIDには依存しない。 */
(function () {
  var SECTION_SELECTOR = '[data-section-type="article"]';
  var instances = [];

  function ArticleToolbarSection(container) {
    var self = this;
    this.id = container.getAttribute('data-section-id');
    this.element = container;
    this.toolbarElement = container.querySelector('.ArticleToolbar');
    this.articleNavElement = container.querySelector('.ArticleNav');
    this.frame = 0;

    this.onScroll = function () {
      if (self.frame) return; // 1フレーム1回（旧fastdomのバッチ相当）
      self.frame = window.requestAnimationFrame(function () {
        self.frame = 0;
        self.checkToolbarVisibility();
      });
    };

    window.addEventListener('scroll', this.onScroll);
  }

  ArticleToolbarSection.prototype.checkToolbarVisibility = function () {
    var toolbarElement = this.toolbarElement;
    if (!toolbarElement || !document.contains(toolbarElement)) return;

    /* --- measure（旧 fastdom.measure 相当。読み取りだけを先に済ませる） --- */
    var header = document.querySelector('.Header');
    var lastYPosition = window.pageYOffset;
    var headerHeight = header ? header.offsetHeight : 0;
    var isFixedHeader = parseInt(window.getComputedStyle(document.body).getPropertyValue('--use-sticky-header') || 0, 10) || 0;
    var navBottom = 0;

    if (this.articleNavElement) {
      navBottom = this.articleNavElement.offsetTop + this.articleNavElement.clientHeight - headerHeight;
    }

    /* --- mutate（旧 fastdom.mutate 相当） ---
       kl-legacy.css:13159-13161 の top:calc(var(--use-sticky-header,0)*var(--header-height)) と
       同値をインラインで上書きする（旧も同じ二重指定だった）。 */
    toolbarElement.style.top = isFixedHeader ? headerHeight + 'px' : '';

    if (this.articleNavElement) {
      if (lastYPosition > 150 && lastYPosition < navBottom) {
        toolbarElement.classList.add('is-visible');
      } else {
        toolbarElement.classList.remove('is-visible');
      }
    } else {
      if (lastYPosition > 150) {
        toolbarElement.classList.add('is-visible');
      } else {
        toolbarElement.classList.remove('is-visible');
      }
    }
  };

  /* 旧 ArticleSection.onUnload（旧theme.js:3953-3965）相当 */
  ArticleToolbarSection.prototype.destroy = function () {
    window.removeEventListener('scroll', this.onScroll);
    if (this.frame) {
      window.cancelAnimationFrame(this.frame);
      this.frame = 0;
    }
  };

  function unregister(id) {
    for (var i = instances.length - 1; i >= 0; i--) {
      if (instances[i].id === id) {
        instances[i].destroy();
        instances.splice(i, 1);
      }
    }
  }

  function register(container) {
    if (!container || !container.querySelector('.ArticleToolbar')) return;
    /* テーマエディタでのセクション再描画は unload → load の順とは限らないため、
       同じ section id の古いインスタンスは必ず捨ててから張り直す（scrollリスナの多重登録防止） */
    unregister(container.getAttribute('data-section-id'));
    instances.push(new ArticleToolbarSection(container));
  }

  Array.prototype.forEach.call(document.querySelectorAll(SECTION_SELECTOR), register);

  /* 旧 SectionContainer._onSectionLoad / _onSectionUnload（旧theme.js:6775-6797）相当。
     旧は event.target 配下の最初の [data-section-id] を拾って data-section-type で
     コンストラクタを引いていた。ここは article 型しか扱わないので直接その型で引く。 */
  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target || !event.target.querySelector) return;
    register(event.target.querySelector(SECTION_SELECTOR));
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.detail) return;
    unregister(event.detail.sectionId);
  });
})();

/* KL: 旧 layout/theme.liquid:154-172 の window.onpageshow の移植。
   旧がしていたことは2つ:
     (a) window.theme.showPageTransition が真なら .PageTransition を
         visibility:visible / opacity:0 に戻す（bfcache復帰時にページ遷移用の黒幕が
         被さったままになるのを解除する＝ローディング解除）。
     (b) document.documentElement へ 'cart:refresh'（bubbles）を発火し、カートを取り直す。
         旧はこれを CartSection が拾い（旧theme.js:4222）、再描画のついでに
         .Header__CartDot / .Header__CartCount を更新していた（旧theme.js:4386-4404）。

   移植時の実情:
     (a) .PageTransition 要素は新テーマのどのテンプレートにも出力されていない（liquid全件grep）ため
         実質no-op。将来復活したときに旧と同じ復帰をするよう、要素の有無だけで判定して残す。
         なお window.theme は新テーマに存在しない（新は window.themeVariables）ので参照しない。
     (b) 'cart:refresh' は v11 theme.js:1330/1345/1466/4478 が listen していてカート状態を取り直す。
         ただし新ヘッダーは v11 の <cart-count> ではなく旧マークアップの
         .Header__CartCount / .Header__CartDot（kl-header.liquid:428,469）を出力しており、
         これを更新する実装が新テーマに1つも無い。旧 CartSection の該当処理（旧theme.js:4386-4404）を
         ここへ引き取る。
     旧は毎回の pageshow で発火していたが、v11 では 'cart:refresh' 1回につき /cart.js が1本増える。
     初回表示はサーバー側が正しい値を描画済みで旧でも実質no-opだったため、
     発火は bfcache 復帰（event.persisted）に限定する。旧の目的（旧コメント
     "When the page is loaded from the cache, we have to reload the cart content"）は満たす。 */
(function () {
  function updateLegacyCartCount() {
    var cartQuantity = document.querySelectorAll('.Header__CartCount');
    var cartDot = document.querySelectorAll('.Header__CartDot');
    if (cartQuantity.length === 0 && cartDot.length === 0) return;

    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    fetch(root + 'cart.js', { credentials: 'same-origin' })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        var itemCount = cart['item_count'];

        /* 旧theme.js:4394-4400: 0件ならドットを消し、1件以上なら出す */
        Array.prototype.forEach.call(cartDot, function (item) {
          if (itemCount === 0) {
            item.classList.remove('is-visible');
          } else {
            item.classList.add('is-visible');
          }
        });

        /* 旧theme.js:4402-4404 */
        Array.prototype.forEach.call(cartQuantity, function (item) {
          item.textContent = itemCount;
        });
      })
      .catch(function () { /* 取得できなければサーバー描画値のまま（旧も失敗時は据え置き） */ });
  }

  document.addEventListener('cart:refresh', updateLegacyCartCount);

  window.addEventListener('pageshow', function (event) {
    var pageTransition = document.querySelector('.PageTransition');
    if (pageTransition) {
      pageTransition.style.visibility = 'visible';
      pageTransition.style.opacity = '0';
    }

    if (!event.persisted) return;

    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  });
})();
